import {readImageEditMask} from './image-edit-mask';
export type ImageEditReference={assetId:string;kind:'identity'|'object'};
import { editorValueSignature } from "./native-envelope";
export type ImageEditRequest = {
  method: "POST";
  path: "/__waka/image-edit";
  body: {
    clipId: string;
    revision: string;
    instruction: string;
    confirmed: true;
    maskBase64?: string;
    references?: ImageEditReference[];
  };
};
export function isImageEditRequest(value: unknown): value is ImageEditRequest {
  if (!value || typeof value !== "object" || Array.isArray(value)) return false;
  const r = value as Record<string, unknown>,
    b = r.body;
  if (
    r.method !== "POST" ||
    r.path !== "/__waka/image-edit" ||
    r.params !== undefined ||
    Object.keys(r).some(
      (k) => !["method", "path", "body", "params"].includes(k),
    ) ||
    !b ||
    typeof b !== "object" ||
    Array.isArray(b)
  )
    return false;
  const v = b as Record<string, unknown>;
  return (
    Object.keys(v).every(k=>['clipId','revision','instruction','confirmed','maskBase64','references'].includes(k)) &&
    validImageEditExtras(v) &&
    typeof v.clipId === "string" &&
    v.clipId.length > 0 &&
    v.clipId.length <= 512 &&
    typeof v.revision === "string" &&
    v.revision.length > 0 &&
    v.revision.length <= 64 &&
    typeof v.instruction === "string" &&
    v.instruction.trim().length > 0 &&
    v.instruction.length <= 2000 &&
    v.confirmed === true
  );
}
export function readImageEditSource(document: unknown, clipId: string) {
  const d = document as {
    items?: Record<string, Record<string, unknown>>;
    assets?: Record<string, Record<string, unknown>>;
    tracks?: { locked?: boolean; items: string[] }[];
  };
  const item = d?.items?.[clipId],
    asset = typeof item?.assetId === "string" ? d.assets?.[item.assetId] : null;
  if (
    item?.type !== "image" ||
    asset?.type !== "image" ||
    typeof asset.remoteUrl !== "string"
  )
    throw Error("수정할 이미지 클립 하나를 선택해 주세요.");
  const track = d.tracks?.filter((t) => t.items.includes(clipId));
  if (track?.length !== 1 || track[0]!.locked)
    throw Error(
      "그룹 안 이미지는 먼저 그룹을 해제하고 트랙 잠금을 풀어 주세요.",
    );
  const url = new URL(asset.remoteUrl);
  if (url.protocol !== "https:" || url.username || url.password)
    throw Error("AI 수정 전에 이미지를 자료함에 업로드해 주세요.");
  return {
    clipId,
    assetId: String(item.assetId),
    url: asset.remoteUrl,
    signature: editorValueSignature({ item, asset }),
  };
}

function validImageEditExtras(v:Record<string,unknown>):boolean{
 try{if(v.maskBase64!==undefined)readImageEditMask(v.maskBase64);}catch{return false;}
 if(v.references===undefined)return true;
 if(!Array.isArray(v.references)||v.references.length>2)return false;
 const ids=new Set<string>();
 return v.references.every(r=>{if(!r||typeof r!=='object'||Array.isArray(r)||Object.keys(r).length!==2||typeof r.assetId!=='string'||!r.assetId||r.assetId.length>512||!['identity','object'].includes(r.kind)||ids.has(r.assetId))return false;ids.add(r.assetId);return true;});
}
/** Resolve references from the same saved document, never from client-supplied URLs. */
export function readImageEditExtras(document:unknown,clipId:string,extras:{maskBase64?:string;references?:ImageEditReference[]}){
 if(!validImageEditExtras(extras))throw Error('수정 영역과 참조 이미지를 다시 선택해 주세요.');
 const source=readImageEditSource(document,clipId);
 const d=document as {assets:Record<string,{type?:string;remoteUrl?:string;width?:number;height?:number}>};
 if(extras.maskBase64){const mask=readImageEditMask(extras.maskBase64),asset=d.assets[source.assetId];if(mask.width!==asset?.width||mask.height!==asset?.height)throw Error('원본 이미지 크기가 바뀌었습니다. 수정 영역을 다시 지정해 주세요.');}
 const refs=extras.references?.map(ref=>{
  const asset=d.assets[ref.assetId];if(ref.assetId===source.assetId||asset?.type!=='image'||!asset.remoteUrl)throw Error('현재 작업의 다른 이미지로 참조를 선택해 주세요.');
  const url=new URL(asset.remoteUrl);if(url.protocol!=='https:'||url.username||url.password)throw Error('참조 이미지를 자료함에 업로드한 뒤 다시 선택해 주세요.');
  return {url:url.href,kind:ref.kind};
 });
 return {...(extras.maskBase64?{maskBase64:extras.maskBase64}:{}),...(refs?.length?{refs}:{})};
}
